<template>
  <div class="service">
    <div class="thump">
      <span class="like icon-like" :class="{ on: now === 1 }" @click="agree(true)">有用{{ likeCount }}</span>
      <span
        class="unlike icon-unlike"
        :class="{ on: now === -1 }"
        @click="agree(false)"
      >无用{{ unlikeCount }}</span>
    </div>
    <div class="custom" @click="contactService">
      <span class="tip">在线人工客服</span>
      <span class="icon icon-service">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import native from '@/utils'
import service from '../service'

const { NativeFuncs, callNativeAsyncFunc } = native

export default {
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      id: '', // 文章ID
      now: 0, // 文章状态，1 - 赞，-1 - 倒，0 - 无
      cache: true, // 存储
    }
  },
  computed: {
    likeCount() {
      const { liked, like_count } = this.article
      return (
        Number(like_count || 0) +
        (liked && this.now !== 1 ? -1 : !liked && this.now === 1 ? 1 : 0)
      )
    },
    unlikeCount() {
      const { unliked, unlike_count } = this.article
      return (
        Number(unlike_count || 0) +
        (unliked && this.now !== -1 ? -1 : !unliked && this.now === -1 ? 1 : 0)
      )
    },
  },
  methods: {
    // 跳转客服页面
    contactService() {
      callNativeAsyncFunc(NativeFuncs.NAVIGATION.CUSTOMER_SERVICE)
      callNativeAsyncFunc(NativeFuncs.NAVIGATION.GENERAL, {
        route: '/customer_service',
        params: {},
      })
    },
    agree(bool) {
      const i = this.now
      this.now = bool && i !== 1 ? 1 : !bool && i !== -1 ? -1 : 0
    },
  },
  mounted() {
    this.id = this.$route.query.id
  },
  updated() {
    const { liked, unliked } = this.article
    if (this.cache && liked !== undefined && liked !== null) {
      this.cache = false
      this.now = liked ? 1 : unliked ? -1 : 0
    }
  },
  beforeDestroy() {
    const { liked, unliked } = this.article
    const init = liked ? 1 : unliked ? -1 : 0
    if (this.now !== init) {
      const url = `articles/${this.id}/${
        !(this.now - 1) || (!this.now && init === 1) ? 'likes' : 'unlikes'
      }`
      service.setLike(url)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../style/func.scss';

.service {
  display: flex;
  justify-content: space-between;
  color: #63c4f8;
  position: absolute;
  left: px2rem(8px);
  bottom: px2rem(4px);
  width: 85%;
  padding: px2rem(8px) px2rem(18px);
  line-height: px2rem(29px);
  background-color: #fff;
  box-shadow: 0 0 5px 3px #e0e0e0;
  border-radius: 4px;

  .thump {
    display: flex;
    justify-content: space-around;
    width: 52%;
    color: #9b9b9b;
    line-height: 1;
    margin: px2rem(6px) 0;
    border-right: 1px solid #d8d8d8;
    box-sizing: border-box;

    .like,
    .unlike {
      &::before {
        font-size: px2rem(15px);
        display: inline-block;
        color: #cacaca;
      }

      &.on::before {
        color: #fa886c;
      }
    }
  }

  .custom {
    display: flex;
    justify-content: flex-end;

    .tip {
      display: inline-block;
      width: px2rem(90px);
    }

    .icon {
      display: inline-block;
      width: px2rem(28px);
      font-size: px2rem(28px);

      .path1,
      .path2,
      .path3 {
        float: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/components/LikeService.vue